import { useMutation } from '@tanstack/react-query'
import { postLogin } from 'services/AuthService'

export const useLoginMutation = () => useMutation({ mutationFn: postLogin })
